import 'es6-shim'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import VueAppend from 'vue-append'
import { sync } from 'vuex-router-sync'
import VueGtag from "vue-gtag";

import configRouter from './config/router'
import vuexStore from './vuex/store'

import App from './App'

Vue.use(VueHead, {
	separator: ''
})
Vue.use(VueAppend)
Vue.use(VueRouter)
Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store(vuexStore)
const router = configRouter(VueRouter)

sync(store, router)

Vue.use(VueGtag, {
  config: {
		id: "G-S6WE8G19YY",
		params: {
			anonymize_ip: true
		}
	},
  bootstrap: false
}, router)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
})

document.addEventListener('touchstart', function onFirstTouch() {
	document.body.classList.remove('has-hover')
	document.removeEventListener('touchstart', onFirstTouch, false)
})

// router.beforeEach((to, from, next) => {
	// console.log(to, from, next)

	// if (from.path.startsWith('/en')) {
	// 	console.log('coming from english')
	// } else {
	// 	console.log('coming from german')
	// }
// 	next()
// })



// WEBPACK FOOTER //
// ./src/main.js